<div>
  <img
    class="clsImgCenterVertical"
    src="assets/images/icons/reload_big_pink.gif"
    alt=""
    width="32px"
    height="32px"
  />
</div>
